import { useEffect, useState } from "react";
import { getListFormFB, getListPageFB } from "../api";

export const useListPageFB = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListPageFB({ ...params });
    if (response.data.status) setData(response.data.data?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};

export const useCountListPageFB = (params) => {
  const [data, setData] = useState(null);
  async function fetchData() {
    const response = await getListPageFB({ ...params });
    if (response.data.status) setData(response.data.data?.total);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
export const useListFormFB = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListFormFB({ ...params });
    if (response.data.status) setData(response.data.data?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};

export const useCountListFormFB = (params) => {
  const [data, setData] = useState(null);
  async function fetchData() {
    const response = await getListFormFB({ ...params });
    if (response.data.status) setData(response.data.data?.total);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
